/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import ContentWrapper from "ui/common/ContentWrapper";
import styles from "./LibraryDetail.module.scss"
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "./LibraryDetailQuery"
import {useParams} from "react-router-dom";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import LibraryDetailBody from "ui/feature/library-detail/LibraryDetailBody";
import {LibraryDetailQuery} from "./__generated__/LibraryDetailQuery.graphql";

const LibraryDetail: React.FC = () => {
    const params = useParams();
    return (
        <ContentWrapper className={styles.container}>
            <QueryRenderer<LibraryDetailQuery>
                environment={environment}
                query={query}
                variables={{piece_id: params.piece_id ?? ""}}
                render={({error, props}) => {
                    if (error) {
                        return <ErrorSection/>;
                    } else if (props) {
                        return <LibraryDetailBody piece={props.music_viewer.piece}/>;
                    } else {
                        return <LoadingSection/>
                    }
                }}/>
        </ContentWrapper>
    )
}

export default LibraryDetail;
